import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Editorial.css';

export default function Editorial() {
  const navigate = useNavigate();

  return (
    <section className="ed">

      {/* ══════════════ ROW 1 ══════════════ */}
      <div className="ed__row">

        <div className="ed__text">
          <p className="ed__eyebrow">S t r e e t &nbsp; L e g a c y</p>
          <h2 className="ed__heading">BORN ON THE BLOCK</h2>
          <p className="ed__body">
            Every silhouette we stock carries a story. From the courts of
            Soweto to the streets of Cape Town — we bring you the kicks
            that built South African street culture, one drop at a time.
          </p>
          <button className="ed__btn" onClick={() => navigate('/products')}>
            Shop The Drop
          </button>
        </div>

        <div className="ed__visual ed__visual--right">
          <div className="ed__blob ed__blob--tr">
            <img
              src="/images/JORDAN1body.png"
              alt="Street legacy shoe"
              className="ed__img"
            />
          </div>
        </div>
      </div>

      {/* ══ CONNECTOR ══ */}
      <div className="ed__connector">
        <img
          src="/logo_nav.png"
          alt="SA Dropped"
          className="ed__connector-img"
        />
      </div>

      {/* ══════════════ ROW 2 ══════════════ */}
      <div className="ed__row ed__row--reverse">

        <div className="ed__visual ed__visual--left">
          <div className="ed__blob ed__blob--bl">
            <img
              src="https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=600&q=85"
              alt="Culture shoe"
              className="ed__img"
            />
          </div>
        </div>

        <div className="ed__text ed__text--right">
          <p className="ed__eyebrow">O u r &nbsp; C u l t u r e</p>
          <h2 className="ed__heading">RETRO NEVER DIES</h2>
          <p className="ed__body">
            The classics keep coming back because they never left.
            Air Force 1s, Dunks, Sambas — SA Dropped keeps the retro
            flame alive with verified pairs, authentic colourways,
            and culture you can actually wear.
          </p>
          <button className="ed__btn" onClick={() => navigate('/products')}>
            View All Pairs
          </button>
        </div>
      </div>

    </section>
  );
}